import { MessagesScreen } from '~/components/domain/messages/MessagesScreen';

export default function MessagesSearch() {
  return <MessagesScreen initialMessageType="search" />;
} 